module.exports = __webpack_public_path__ + "img/img38.e0a2e771.png";